export default "__VITE_ASSET__CyKggTFz__"